import React from "react";
import Modal from "../../Modal";
import Button from "../../Button";
import { Icon } from "../../Icon/Icon";
import { observer } from "mobx-react-lite";
export const AlertLeavingModal = observer(({ onExit, onClose }) => {
    return (React.createElement(Modal, { dataCySuffix: "alert-leaving", headerText: "Friendly Headsup!", contentClassName: "flex flex-col gap-6 px-6", containerClassName: "min-w-[366px] max-w-[390px] w-full", headerClassName: "typography-h3 bg-delete-color" },
        React.createElement("div", { className: "flex flex-col items-center gap-4" },
            React.createElement(Icon, { className: "sun-attention-icon" }),
            React.createElement("div", { className: "flex flex-col gap-[6px] text-center text-text-color" },
                React.createElement("p", { className: "typography-main_sb" },
                    "You have ",
                    React.createElement("span", { className: "typography-h3" }, "unsaved"),
                    " changes!"),
                React.createElement("p", { className: "typography-main" }, "If you leave now, your progress will be lost."))),
        React.createElement("div", { className: "flex gap-4" },
            React.createElement(Button, { autoLoading: true, size: "big", color: "red", className: "flex-1", onClick: onExit }, "Exit Now"),
            React.createElement(Button, { autoLoading: true, size: "big", color: "main", className: "flex-1", onClick: onClose }, "Keep Going"))));
});
//# sourceMappingURL=AlertLeavingModal.js.map